import { FC, ReactNode } from 'react';
import { FormProvider } from 'react-hook-form';
import { useCashAccountForm } from '../hooks';
import { CashAccountFormContextProvider } from '../context';

interface CashAccountFormProps {
  children?: ReactNode;
  className?: HTMLFormElement['className'];
  useCashAccountFormReturn: ReturnType<typeof useCashAccountForm>;
}

export const CashAccountForm: FC<CashAccountFormProps> = ({
  children,
  className,
  useCashAccountFormReturn: { formMethods, cashAccount, householdID, onSubmit },
}) => {
  return (
    <FormProvider {...formMethods}>
      <CashAccountFormContextProvider cashAccount={cashAccount} householdID={householdID}>
        <form className={className} onSubmit={formMethods.handleSubmit(onSubmit)} role={'form'}>
          {children}
        </form>
      </CashAccountFormContextProvider>
    </FormProvider>
  );
};
